import { render } from "./ResortForm.vue?vue&type=template&id=7175754e"
import script from "./ResortForm.vue?vue&type=script&lang=js"
export * from "./ResortForm.vue?vue&type=script&lang=js"

import "./ResortForm.vue?vue&type=style&index=0&id=7175754e&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__